__turbopack_context__.v({
  "Saturation": "SaturationControl-module-scss-module__i2rIdG__Saturation",
});
